import ExpandOnHover from "../shared/ExpandOnHover";
import AppContext from "../../context/Context";
import { getImages } from "../../context/Actions";
import { useEffect, useContext } from "react";
import Loader from "../shared/Loader";

export default function Gallery() {
    const { isLoading, images, dispatch } = useContext(AppContext);

    useEffect(() => {
        dispatch({ type: "SET_LOADING" });
        const getImagesList = async () => {
            const fetchedImages = await getImages();
            dispatch({ type: "GET_IMAGES", payload: fetchedImages });
        };
        getImagesList();
    }, [dispatch]);

    if (isLoading) return <Loader />;

    const renderImages = (listOfImages) => {
        return listOfImages.map((image) => {
            return (
                <ExpandOnHover key={image._id}>
                    <figure id="img-item" className="image">
                        <img
                            id="gallery-item"
                            loading="lazy"
                            src={image.imgUrl}
                            alt={image.altText}
                        />
                        <figcaption id="image-caption">
                            <h3>{image.title}</h3>
                            <p>{`${image.date}`}</p>
                        </figcaption>
                    </figure>
                </ExpandOnHover>
            );
        });
    };

    const handleShuffle = () => {
        const shuffledImages = images.sort(() => 0.5 - Math.random());
        dispatch({ type: "SHUFFLE_IMAGES", payload: shuffledImages });
    };

    return (
        <main className="container is-fluid">
            <section className="block has-text-centered">
                <h1 className="title is-1">Gallery</h1>
                <button
                    onClick={() => handleShuffle()}
                    className="button is-dark is-outlined"
                >
                    <i className="fa fa-random"></i>
                    Shuffle
                </button>
            </section>
            <section className="block gallery" style={{}}>
                {renderImages(images)}
            </section>
        </main>
    );
}
